module.exports = __webpack_public_path__ + "static/media/HCMM638.84e309b9.jpg";